<template>
  <v-card class="rounded-card card-shadow">
    <v-card-title class="headline font-weight-bold pa-5">
      Minha avaliação
    </v-card-title>
    <v-card-text class="text--primary pa-5">
      <v-row no-gutters>
        <v-col cols="6">
          <v-icon large color="yellow darken-1">
            mdi-star
          </v-icon>
          <span class="headline font-weight-bold ml-3">
        <template v-if="fornecedor.pessoa.entidade.pontuacaoMedia">
          {{ fornecedor.pessoa.entidade.pontuacaoMedia | pxSimpleNumber(1) }}
          <span class="font-weight-medium body-1">
            de 5,0
          </span>
        </template>
        <template v-else>
          Sem avaliação
        </template>
      </span>
        </v-col>
        <v-col cols="6" class="text-right">
          <v-btn fab depressed class="ml-3" small color="primary" to="/minha-pagina#avaliacao">
            <v-icon>mdi-arrow-top-right</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    fornecedor: Object,
  },
};
</script>
